import { atom } from "jotai";
import { currentUserAtom, isAuthenticatedAtom } from "./auth.atoms";
import { GuestNotificationFeed } from "@/src/services/guestNotificationFeed";

export const notificationUserIdAtom = atom((get) =>
  get(isAuthenticatedAtom) ? (get(currentUserAtom)?.id ?? null) : null,
);
export const guestNotificationFeedAtom = atom((get) =>
  get(notificationUserIdAtom) === null ? null : new GuestNotificationFeed(),
);
